import React from 'react'
import { Form, Input, Checkbox, Button, message } from 'antd'
import { EnvironmentOutlined } from '@ant-design/icons'
import BasicConfig from '@/config/basic'
import RadioButtonF from '@/i2antdV5/RadioButtonF'

const FormItem = Form.Item
const { TextArea } = Input
const CheckboxGroup = Checkbox.Group

// 客户标签选项
const TAG_OPTIONS = [
  { id: 'VIP', value: 'VIP' }
]

// 渠道选项
const CHANNEL_OPTIONS = [
  { id: 'xiaohongshu', value: '小红书' },
  { id: 'douyin', value: '抖音' },
  { id: 'weixin', value: '微信' },
  { id: 'other', value: '其他' }
]

class CustomerForm extends React.Component {
  state = {
    loadingCoordinates: false
  }

  componentDidMount() {
    const { form, editingCustomer } = this.props
    if (form && form.current) {
      // 获取当前登录用户信息
      const currentUser = this.props.currentUser || {}
      const userName = currentUser.user_name || currentUser.name || currentUser.username || ''
      
      if (editingCustomer) {
        // 编辑模式：设置表单值
        const channel = editingCustomer.channel
        const isOther = !CHANNEL_OPTIONS.find(opt => opt.id === channel)
        
      const formValues = {
        name: editingCustomer.name,
        phone: editingCustomer.phone,
        address: editingCustomer.address,
        longitude: editingCustomer.points && editingCustomer.points.length > 0 ? editingCustomer.points[0] : undefined,
        latitude: editingCustomer.points && editingCustomer.points.length > 1 ? editingCustomer.points[1] : undefined,
        tags: editingCustomer.tags || [],
          channel: isOther ? 'other' : channel,
          otherChannel: isOther ? channel : '',
          createdBy: editingCustomer.createdBy || userName,
          favoriteFood: editingCustomer.preferences?.favoriteFood || '',
          personality: editingCustomer.preferences?.personality || '',
          hobbies: editingCustomer.preferences?.hobbies || ''
      }
      form.current.setFieldsValue(formValues)
      } else {
        // 新建模式：自动填充当前用户
        form.current.setFieldsValue({
          createdBy: userName
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { form, editingCustomer } = this.props
    // 当编辑客户变化时，更新表单值
    if (form && form.current && editingCustomer && prevProps.editingCustomer !== editingCustomer) {
      const currentUser = this.props.currentUser || {}
      const userName = currentUser.user_name || currentUser.name || currentUser.username || ''
      const channel = editingCustomer.channel
      const isOther = !CHANNEL_OPTIONS.find(opt => opt.id === channel)
      
      const formValues = {
        name: editingCustomer.name,
        phone: editingCustomer.phone,
        address: editingCustomer.address,
        longitude: editingCustomer.points && editingCustomer.points.length > 0 ? editingCustomer.points[0] : undefined,
        latitude: editingCustomer.points && editingCustomer.points.length > 1 ? editingCustomer.points[1] : undefined,
        tags: editingCustomer.tags || [],
        channel: isOther ? 'other' : channel,
        otherChannel: isOther ? channel : '',
        createdBy: editingCustomer.createdBy || userName,
        favoriteFood: editingCustomer.preferences?.favoriteFood || '',
        personality: editingCustomer.preferences?.personality || '',
        hobbies: editingCustomer.preferences?.hobbies || ''
      }
      form.current.setFieldsValue(formValues)
    }
    // 当没有编辑客户时，重置表单
    if (form && form.current && !editingCustomer && prevProps.editingCustomer) {
      const currentUser = this.props.currentUser || {}
      const userName = currentUser.user_name || currentUser.name || currentUser.username || ''
      form.current.resetFields()
      // 重置后自动填充当前用户
      form.current.setFieldsValue({
        createdBy: userName
      })
    }
  }

  /**
   * 根据地址获取经纬度
   */
  handleGetCoordinates = async () => {
    const { form } = this.props
    if (!form || !form.current) return

    try {
      // 获取地址
      const address = form.current.getFieldValue('address')
      if (!address || !address.trim()) {
        message.warning('请先输入地址')
        return
      }

      this.setState({ loadingCoordinates: true })

      // 使用高德地图地理编码API
      const amapKey = BasicConfig.amapKey || ''
      if (!amapKey) {
        message.error('地图服务未配置，无法获取经纬度')
        this.setState({ loadingCoordinates: false })
        return
      }

      const response = await fetch(
        `https://restapi.amap.com/v3/geocode/geo?key=${amapKey}&address=${encodeURIComponent(address)}&output=json`
      )

      if (!response.ok) {
        throw new Error('请求失败')
      }

      const data = await response.json()
      
      if (data.status === '1' && data.geocodes && data.geocodes.length > 0) {
        const location = data.geocodes[0].location // 格式：经度,纬度
        const [longitude, latitude] = location.split(',').map(Number)
        
        // 设置经纬度到表单
        form.current.setFieldsValue({
          longitude: longitude.toFixed(6),
          latitude: latitude.toFixed(6)
        })
        message.success('经纬度获取成功')
      } else {
        message.warning('未找到该地址对应的经纬度，请检查地址是否正确')
      }
    } catch (error) {
      console.error('获取经纬度失败:', error)
      message.error('获取经纬度失败，请稍后重试')
    } finally {
      this.setState({ loadingCoordinates: false })
    }
  }

  render() {
    const { form } = this.props

    return (
      <Form
        ref={form}
        layout="vertical"
        initialValues={{
          tags: []
        }}
      >
        <FormItem
          label="客户信息"
          style={{ marginBottom: 0 }}
        >
          <div style={{ display: 'flex', gap: '16px' }}>
        <FormItem
          label="客户姓名"
          name="name"
          rules={[{ required: true, message: '请输入客户姓名' }]}
              style={{ flex: 1, marginBottom: 0 }}
        >
          <Input placeholder="请输入客户姓名" />
        </FormItem>
        <FormItem
          label="手机号"
          name="phone"
          rules={[
            { required: true, message: '请输入手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
          ]}
              style={{ flex: 1, marginBottom: 0 }}
        >
          <Input placeholder="请输入手机号" maxLength={11} />
            </FormItem>
          </div>
        </FormItem>

        <FormItem
          label="地址"
          name="address"
          rules={[{ required: true, message: '请输入地址' }]}
        >
          <TextArea 
            placeholder="请输入地址" 
            rows={2}
            showCount
            maxLength={200}
          />
        </FormItem>
        <FormItem
          label="客户标签"
          name="tags"
        >
          <CheckboxGroup options={TAG_OPTIONS.map(opt => ({ label: opt.value, value: opt.id }))} />
        </FormItem>

        <FormItem
          label="渠道"
          name="channel"
          rules={[{ required: true, message: '请选择渠道' }]}
        >
          <RadioButtonF
            options={CHANNEL_OPTIONS}
          />
        </FormItem>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.channel !== currentValues.channel
          }
        >
          {({ getFieldValue, setFieldsValue }) => {
            const channel = getFieldValue('channel')
            const isOtherChannel = channel === 'other'
            
            // 当从"其他"切换到其他选项时，清空输入框
            if (!isOtherChannel) {
              const currentOtherChannel = getFieldValue('otherChannel')
              if (currentOtherChannel) {
                setFieldsValue({ otherChannel: '' })
              }
            }
            
            return isOtherChannel ? (
              <FormItem
                label="其他渠道"
                name="otherChannel"
                rules={[
                  { required: true, message: '请输入其他渠道名称' },
                  { max: 50, message: '渠道名称不能超过50个字符' }
                ]}
              >
                <Input 
                  placeholder="请输入其他渠道名称"
                  maxLength={50}
                  showCount
                />
              </FormItem>
            ) : null
          }}
        </Form.Item>

        <FormItem
          label="录入人员"
          name="createdBy"
          rules={[{ required: true, message: '请输入录入人员' }]}
        >
          <Input placeholder="请输入录入人员姓名" />
        </FormItem>

        <FormItem
          label="客户偏好"
          style={{ marginBottom: 0 }}
        >
          <FormItem
            label="喜欢吃什么"
            name="favoriteFood"
            style={{ marginBottom: '16px' }}
          >
            <TextArea 
              rows={2}
              placeholder="请输入客户喜欢吃的食物，例如：喜欢清淡的粤菜，特别偏爱白切鸡和蒸鱼"
              showCount
              maxLength={200}
            />
          </FormItem>
          <FormItem
            label="个人性格"
            name="personality"
            style={{ marginBottom: '16px' }}
          >
            <TextArea 
              rows={2}
              placeholder="请输入客户的个人性格，例如：性格温和，待人友善，比较注重细节"
              showCount
              maxLength={200}
            />
          </FormItem>
          <FormItem
            label="独特爱好"
            name="hobbies"
            style={{ marginBottom: 0 }}
          >
            <TextArea 
              rows={2}
              placeholder="请输入客户的独特爱好，例如：喜欢阅读、听音乐，偶尔会做瑜伽"
              showCount
              maxLength={200}
            />
          </FormItem>
        </FormItem>
      </Form>
    )
  }
}

export default CustomerForm

